import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  store_login: "/login/store/", // + store_token
  login: "/login",
  register: "/register",
  forgot: "/forgot-password"
};
